// Refactored React Component Structure for DMARC Checker Page

import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import {Helmet} from '@dr.pogodin/react-helmet';
import {StructuredContentService} from '../../../../service/SEO/StructuredContentService';
import baseHostname from '../../../../hostname';
import {routes} from '../../../../routes';
import appname from '../../../../appname';

// Components
import {HeroSection} from './HeroSection';
import {DomainCheckerForm} from './DomainCheckerForm';
import PainPointSection from './PainPointSection';
import WhyTrustUsSection from './WhyTrustUsSection';
import WhatIsDMARCSection from './WhatIsDMARCSection';
import FeatureGridSection from './FeatureGridSection';
import FeatureCardsSection from './FeatureCardsSection';
import {BookCallModal} from '../../common/BooKCallModal';
import {FAQ} from "../../common/FAQ";
import {I18nService} from "../../../../service/i18nService";

export const DMARCChecker = () => {
    const {t, i18n} = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [domain, setDomain] = useState('');
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const i18nService = new I18nService();
    const currentLang = i18nService.getLanguage();

    const fetchDmarcRecord = async (e) => {
        e.preventDefault();
        setLoading(true);
        fetch(`${baseHostname}/index.php/domain/analyze`, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({source: 'DMARC', domain})
        })
            .then(res => res.ok ? res.json() : null)
            .then(data => {
                if (data) {
                    dispatch({type: 'SET_DMARC_ANALYZE_RESULT', payload: {result: data, domain: domain}});
                    navigate(`/${currentLang}/${routes['dmarcResult'][currentLang]}`);
                }
            })
            .catch(console.error)
            .finally(() => setLoading(false));
    };

    const mySelfWithLanguage = (lang) => `${appname}/${lang}/${routes['dmarcRecordChecker'][lang]}`;
    const items = t('pages.dmarcChecker.whyDmarc.faq.list', {returnObjects: true});
    const schema = new StructuredContentService().generate(items, currentLang);

    return (
        <>
            <Helmet htmlAttributes={{lang: currentLang}}>
                <title>{t('pages.dmarcChecker.meta.title')}</title>
                <meta name="description" content={t('pages.dmarcChecker.meta.description')}/>
                <meta name="robots" content="index, follow"/>
                <link rel="canonical" href={mySelfWithLanguage(currentLang)}/>
                <meta property="og:title" content={t('pages.dmarcChecker.meta.ogTitle')}/>
                <meta property="og:description" content={t('pages.dmarcChecker.meta.description')}/>
                <meta property="og:type" content="website"/>
                <meta property="og:url" content={mySelfWithLanguage(currentLang)}/>
                <meta property="og:image"
                      content="https://dmarcflow.com/static/media/dmarc-flow-logo.d39195463fda1d6e5352.png"/>
                <meta name="twitter:card" content="summary_large_image"/>
                <meta name="twitter:title" content={t('pages.dmarcChecker.meta.title')}/>
                <meta name="twitter:description" content={t('pages.dmarcChecker.meta.description')}/>
                <meta name="twitter:image"
                      content="https://dmarcflow.com/static/media/dmarc-flow-logo.d39195463fda1d6e5352.png"/>
                <link rel="alternate" hrefLang="en" href={mySelfWithLanguage('en')}/>
                <link rel="alternate" hrefLang="de" href={mySelfWithLanguage('de')}/>
                <link rel="alternate" hrefLang="x-default" href={mySelfWithLanguage('en')}/>
                <script type="application/ld+json">{JSON.stringify(schema)}</script>
            </Helmet>

            <HeroSection/>
            <DomainCheckerForm
                domain={domain}
                setDomain={setDomain}
                fetchDmarcRecord={fetchDmarcRecord}
                loading={loading}
            />
            <PainPointSection openModal={() => setShowModal(true)}/>
            <WhyTrustUsSection openModal={() => setShowModal(true)}/>
            <WhatIsDMARCSection openModal={() => setShowModal(true)}/>
            <FeatureGridSection/>
            <FeatureCardsSection/>
            <FAQ faqItems={items} title={t('pages.dmarcChecker.whyDmarc.faq.title')}
                 subTitle={t('pages.dmarcChecker.whyDmarc.faq.subTitle')}></FAQ>

            {/*<StickyCTA*/}
            {/*    onScan={() => window.scrollTo({ top: 0, behavior: 'smooth' })}*/}
            {/*    onExpert={() => setShowModal(true)}*/}
            {/*/>*/}

            <BookCallModal show={showModal} handleClose={() => setShowModal(false)}/>
        </>
    );
};
